import { Row } from 'antd';
import InputFieldsGenerator from 'components/InputFieldsGenerator';
import { InputProps } from 'components/InputFieldsGenerator/types';
import { ERRORS } from 'constants/notify';
import { Form, Formik } from 'formik';
import React, { useMemo } from 'react';
import PortalProfileSaveButton from 'routes/Profile/components/ProfileContent/PortalProfileSaveButton';
import { FormActionButtonStyled } from 'routes/Profile/components/ProfileContent/styled';
import { GeneralFunction } from 'types/common';
import { defaultNotification } from 'utils';
import * as Yup from 'yup';

interface ICommonCompanyFormProps {
  inputProps: InputProps[];
  onSave?: GeneralFunction;
  updateCompany?: GeneralFunction;
  validationObject?: Record<string, any>;
  initData?: Record<string, any>;
  portalButtonClassName?: string;
  loading?: boolean;
  callbackOnSaveSuccess?: GeneralFunction;
  buttonLabel?: string;
}

const CommonCompanyForm: React.FC<ICommonCompanyFormProps> = ({
  inputProps,
  onSave,
  validationObject,
  portalButtonClassName,
  loading,
  initData,
  updateCompany,
  callbackOnSaveSuccess,
  buttonLabel,
}) => {
  const portalSaveButtonContainerClass = portalButtonClassName || '.custom-tabs-content-active .gx-tab-content-header';

  const initialValues = useMemo(
    () =>
      inputProps.reduce((acc, inp) => {
        acc[inp.name] = initData?.[inp.name];
        if (inp.sideFields) {
          inp.sideFields.forEach((side) => {
            acc[side.name] = initData?.[side.name];
          });
        }
        return acc;
      }, {} as Record<string, any>),
    [inputProps, initData],
  );

  const validationSchema = useMemo(() => Yup.object(validationObject), [validationObject]);

  const onSubmit = async (v: Record<string, any>) => {
    if (onSave) {
      onSave?.(v);
      return;
    }
    if (!updateCompany) {
      return;
    }
    try {
      await updateCompany(v);
      defaultNotification({ success: 'Update company successfully!' });
      callbackOnSaveSuccess?.();
    } catch (err) {
      defaultNotification({ failure: ERRORS.DEFAULT_MUTATION_ERROR });
    }
  };

  return (
    <Formik enableReinitialize initialValues={initialValues} validationSchema={validationSchema} onSubmit={onSubmit}>
      {(props) => (
        <Form>
          <InputFieldsGenerator formFields={inputProps} />
          <Row justify='start' className='form-buttons-wrapper'>
            <PortalProfileSaveButton containerClass={portalSaveButtonContainerClass}>
              <FormActionButtonStyled
                isLoading={loading}
                buttonType='primary'
                className='gx-mb-0 gx-mr-0'
                onClick={() => {
                  props.handleSubmit();
                }}>
                <div>{buttonLabel || 'Save'}</div>
              </FormActionButtonStyled>
            </PortalProfileSaveButton>
          </Row>
        </Form>
      )}
    </Formik>
  );
};

export default CommonCompanyForm;
